import { useState } from 'react';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import Icon, { IconType } from '../Icon/Icon';
import Modal from '../Modal/Modal';

export type SetEntryIdSaveResult = {
  displayId: string;
  fixedId: string | null;
};

interface IProps {
  title?: string;
  students?: string;
  currentId: string;
  projectIntId: number;
  setModalOpen: (open: boolean) => void;
  onSaved: (result: SetEntryIdSaveResult) => void;
}

const SetEntryIdModal = (props: IProps) => {
  const [projectId, setProjectId] = useState(props.currentId ?? '');

  const onSave = () => {
    const value = (projectId ?? '').trim();
    if (!value) {
      toast.warning('Please provide a valid entry id.');
      return;
    }
    if (!props.projectIntId) {
      toast.warning('This person is not linked to an entry.');
      return;
    }

    store.server
      .postApi<ServerResponse<SetEntryIdSaveResult>>('../EntryId/SetEntryId', {
        projectIntId: props.projectIntId,
        projectId: value,
      })
      .then((x) => {
        if (x.Success) {
          toast.success('Entry id saved.');
          props.onSaved({
            displayId: x.Value?.displayId || value,
            fixedId: x.Value?.fixedId ?? value,
          });
          props.setModalOpen(false);
        } else {
          toast.error(x.Message, { autoClose: false });
        }
      });
  };

  return (
    <Modal setModalOpen={props.setModalOpen} title="Set Entry Id:" size="l">
      <div className="form-horizontal">
        {props.title ? (
          <div className="form-group">
            <label className="control-label col-sm-4">Title</label>
            <div className="col-sm-8 form-control-static">{props.title}</div>
          </div>
        ) : null}
        {props.students ? (
          <div className="form-group">
            <label className="control-label col-sm-4">Student(s)</label>
            <div className="col-sm-8 form-control-static">{props.students}</div>
          </div>
        ) : null}
        <div className="form-group">
          <label className="control-label col-sm-4" htmlFor="people-set-entry-id">
            Entry Id
          </label>
          <div className="col-sm-4">
            <input
              id="people-set-entry-id"
              type="text"
              maxLength={20}
              placeholder="Entry Id"
              className="form-control"
              autoFocus={true}
              value={projectId}
              onChange={(e) => setProjectId(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  onSave();
                }
              }}
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-sm-8 col-sm-offset-4">
            <button type="button" className="btn btn-secondary" onClick={onSave} data-testid="set-entry-id-save">
              <Icon type={IconType.save} /> Save
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SetEntryIdModal;
